'use client'

import {Breadcrumb, Button, Flex, Space} from 'antd'
import {ChevronLeft, Home} from 'lucide-react'
// @ts-ignore
import {useRouter} from 'nextjs-toploader/app'

import * as UI from './breadcrumbs.styled'
import React, {useCallback, useMemo} from 'react'

export const Breadcrumbs = (
  props: BreadcrumbProps & {className?: string; extra?: React.ReactNode},
) => {
  const router = useRouter()
  const {items: itemsList} = props

  const items = [
    {
      href: '/',
      title: (
        <Space>
          <Flex align="baseline" gap={6}>
            <Home size={14} style={{alignSelf: 'anchor-center'}} />
            <span>Главная</span>
          </Flex>
        </Space>
      ),
    },
    ...itemsList.map(item => ({
      href: item.url ?? undefined,
      title: (
        <Space align="center">
          <span>{item.title}</span>
        </Space>
      ),
    })),
  ]

  const needBackButton = useMemo(() => {
    if (items.length > 2) {
      return true
    } else {
      return false
    }
  }, [items])

  const prevItem = useMemo(() => {
    if (items.length > 1) {
      const lastIndex = items.length - 1

      if (items[lastIndex - 1]!.href != '/') {
        return items[lastIndex - 1]
      }
    }
  }, [items])

  const prevItemIsHome = useMemo(() => {
    if (prevItem) {
      return prevItem.href == '/'
    }
    return false
  }, [prevItem])

  // const lastItem = useMemo(() => {
  //   if (items.length > 1) {
  //     return _.last(items) as ArrayItem<typeof items>
  //   }
  // }, [items])

  const goPrev = useCallback(() => {
    if (prevItem?.href) {
      router.push(prevItem.href)
    }
  }, [router, prevItem])

  return (
    <UI.Wrapper className={props.className}>
      {items.length > 0 && (
        <>
          <UI.MobileBreadcrumbs>
            {(needBackButton && !prevItemIsHome && (
              <UI.MobileBreadcrumb as={Button} type="text" size="small" onClick={goPrev}>
                <ChevronLeft size={18} />
                Назад
              </UI.MobileBreadcrumb>
            )) || (
              <UI.MobileBreadcrumb as={Button} type="text" size="small">
                <Home size={14} style={{alignSelf: 'anchor-center'}} />
                Главная
              </UI.MobileBreadcrumb>
            )}
            {/*<UI.MobileBreadcrumb>/</UI.MobileBreadcrumb>*/}

            {/*{lastItem && <UI.MobileBreadcrumb>{lastItem.title}</UI.MobileBreadcrumb>}*/}
          </UI.MobileBreadcrumbs>

          <UI.StyledBreadCrumb
            as={Breadcrumb}
            separator="/"
            itemRender={item =>
              (item.href && (
                <Button
                  type="text"
                  size="small"
                  href={item.href}
                  onClick={ev => {
                    ev.preventDefault()
                    router.push(item.href!)
                  }}>
                  {item.title}
                </Button>
              )) || (
                <UI.StyledBreadCrumbText as={Button} type="text" size="small">
                  {item.title}
                </UI.StyledBreadCrumbText>
              )
            }
            items={items}
          />

          {props.extra}
        </>
      )}
    </UI.Wrapper>
  )
}
